const host = window.location.hostname;

// let BASE_API = 'http://localhost:8080/api';
// let BASE_URL = 'http://localhost:8080/api/v1/files';

// let BASE_API = 'https://devapi.dentaljob.co.kr/api';
// let BASE_URL = 'https://devapi.dentaljob.co.kr/api/v1/files';

let BASE_API = 'https://api.dentaljob.co.kr/api';
let BASE_URL = 'https://api.dentaljob.co.kr/api/v1/files';


let DOMAIN_USER = 'https://dentaljob.co.kr';
let DOMAIN_ADMIN = 'https://wm.dentaljob.co.kr';

if (host === 'devu.dentaljob.co.kr') {
    BASE_API = 'https://devapi.dentaljob.co.kr/api';
    BASE_URL = 'https://devapi.dentaljob.co.kr/api/v1/files';
    DOMAIN_USER = 'https://devu.dentaljob.co.kr';
    DOMAIN_ADMIN = 'https://devw.dentaljob.co.kr';
}

export { BASE_API, BASE_URL, DOMAIN_USER, DOMAIN_ADMIN };
export const APPKEY = '869ab5fe9a813cbd0afa8472d40e2c2d';

// GA4 - phải trùng với id trong public/index.html
export const GA_MEASUREMENT_ID = 'G-2J15VE26Q8';

export const MENU_RECRUIT = [
    { url: '/paeaa010', context: '통합', urlCpnItem: '/paeaa070', internalUrl: ['/paeaa010'] },
    { url: '/paeaa013', context: '지역별', urlCpnItem: '/paeaa070', internalUrl: ['/paeaa013'] },
    { url: '/paeaa014', context: '역세권별', urlCpnItem: '/paeaa070', internalUrl: ['/paeaa014'] },
    { url: '/paeaa011', context: '업무별', urlCpnItem: '/paeaa070', internalUrl: ['/paeaa011'] },
    { url: '/paeaa012', context: '자격증별', urlCpnItem: '/paeaa070', internalUrl: ['/paeaa012'] },
    { url: '/paeaa015', context: '채용형태별', urlCpnItem: '/paeaa070', internalUrl: ['/paeaa015'] },
    { url: '/paeaa016', context: '사업장별', urlCpnItem: '/paeaa070', internalUrl: ['/paeaa016'] },
    { url: '/paeaa017', context: '복리후생별', urlCpnItem: '/paeaa070', internalUrl: ['/paeaa017'] },
];

export const MENU_RESUME = [
    { url: '/pafaa010', context: '통합', urlCpnItem: '/pafaa060', internalUrl: ['/pafaa010'] },
    { url: '/pafaa011', context: '지역별', urlCpnItem: '/pafaa060', internalUrl: ['/pafaa011'] } /* PAFAA010 Tab 1 */,
    { url: '/pafaa012', context: '업무별', urlCpnItem: '/pafaa060', internalUrl: ['/pafaa012'] } /* PAFAA010 Tab 2 */,
    {
        url: '/pafaa013',
        context: '자격증별',
        urlCpnItem: '/pafaa060',
        internalUrl: ['/pafaa013'],
    } /* PAFAA010 Tab 4 Line 1 */,
    {
        url: '/pafaa014',
        context: '채용형태별',
        urlCpnItem: '/pafaa060',
        internalUrl: ['/pafaa014'],
    } /* PAFAA010 Tab 4 Line 2 */,
    {
        url: '/pafaa015',
        context: '경력별',
        urlCpnItem: '/pafaa060',
        internalUrl: ['/pafaa015'],
    } /* PAFAA010 Tab 4 Line 5 */,
    {
        url: '/pafaa016',
        context: '직급',
        urlCpnItem: '/pafaa060',
        internalUrl: ['/pafaa016'],
    } /* PAFAA010 Tab 4 Line 3 */,
];

export const MENU_DENTAL_PLUS = [
    { url: '/pagaa010', context: '자원봉사', urlCpnItem: '', internalUrl: ['/pagaa020'] },
    { url: '/pagab010', context: '이벤트', urlCpnItem: '', internalUrl: ['/pagab020'] },
    { url: '/pagaj010', context: '법정의무교육', urlCpnItem: '' },
    { url: '/pagah010', context: '덴탈잡 모바일앱', urlCpnItem: '' },
    { url: '/pagai010', context: '문서서식', urlCpnItem: '' },
    { url: '/pagac010', context: '덴탈 매거진', urlCpnItem: '', internalUrl: ['/pagac020'] },
];

export const MENU_CUSTOMER_SERVICE_CENTER = [
    { url: '/pahaa010', context: '홈', urlCpnItem: '' },
    { url: '/pahab010', context: '채용광고 상품안내', urlCpnItem: '' },
    { url: '/pahac010', context: '이용안내', urlCpnItem: '' },
    { url: '/pahad010', context: '이메일 문의', urlCpnItem: '' },
    { url: '/pahae010', context: '자주 묻는 질문', urlCpnItem: '' },
    { url: '/pahaf010', context: '공지/소식', urlCpnItem: '', internalUrl: ['/pahaf020'] },
    { url: '/pahag010', context: '사이트 소개', urlCpnItem: '' },
    { url: '/pahah010', context: '회원약관', urlCpnItem: '' },
];

// P
export const MENU_SIDENAV_USER = [
    { url: '/paiaa010', context: '마이 페이지', icon: 'icon icon-user-subpage' },
    {
        urlCommon: '/paiab010',
        urlCpnItem: '/paiaa010',
        context: '이력서 등록',
        icon: 'icon icon-resume-add',
        url: '/paiab010',
    },
    {
        urlCommon: '/paiab020',
        urlCpnItem: '/paiaa010',
        context: '이력서 관리',
        icon: 'icon icon-document-subpage',
        url: '/paiab020',
        // child: [
        //     { url: '/paiab010', urlCpnItem: '/paiaa010', content: '이력서 등록' },
        //     { url: '/paiab020', urlCpnItem: '/paiaa010', content: '이력서 관리' },
        // ],
    },
    { url: '/paiac010', urlCpnItem: '/paiaa010', context: '지원 현황', icon: 'icon icon-list-two' },
    { url: '/paiad010', urlCpnItem: '/paiaa010', context: '추천 공고', icon: 'icon icon-light-bulb' },
    { url: '/paiae010', urlCpnItem: '/paiaa010', context: '스크랩', icon: 'icon icon-nav-star' },
    {
        url: '/paiaf010',
        // url: '/PAIAF030',
        urlCpnItem: '/paiaa010',
        context: '쪽지',
        icon: 'icon icon-nav-letter',
        internalUrl: ['/paiaf020'],
    },
    { url: '/paiah020', urlCpnItem: '/paiaa010', context: '내 정보 수정', icon: 'icon icon-nav-setting' },
    { url: '/paiah030', urlCpnItem: '/paiaa010', context: '회원탈퇴', icon: 'icon icon-nav-logout' },
];

// C
export const MENU_SIDENAV_DENTAL = [
    { url: '/pajaa010', urlCpnItem: '', context: '마이 페이지', icon: 'icon icon-user-subpage' },
    { url: '/pajab010', urlCpnItem: '/pajab020', context: '치과정보 관리', icon: 'icon icon-nav-docs' },
    {
        urlCommon: '/pajac020',
        urlCpnItem: '/pajaa010',
        context: '채용공고 등록',
        icon: 'icon icon-recruit-add',
        url: '/pajac020',
    },
    {
        urlCommon: '/pajac010',
        urlCpnItem: '/pajaa010',
        context: '채용정보 관리/영수증',
        icon: 'icon icon-nav-list',
        url: '/pajac010',
        // child: [
        //     { url: '/pajac020', urlCpnItem: '/pajaa010', content: '채용공고 등록' },
        //     { url: '/pajac010', urlCpnItem: '/pajaa010', content: '채용공고 관리/영수증' },
        // ],
    },
    { url: '/pajad010', urlCpnItem: '/pajaa010', context: '지원자 관리', icon: 'icon icon-nav-user' },
    { url: '/pajae010', urlCpnItem: '/pajaa010', context: '덴탈잡 이용권 관리', icon: 'icon icon-nav-ticket' },
    { url: '/pajak010', urlCpnItem: '/pajak010', context: '열람권 관리/영수증', icon: 'icon icon-nav-docs' },
    { url: '/pajal010', urlCpnItem: '/pajal010', context: '열람권 사용 현황', icon: 'icon icon-list-two' },
    { url: '/pajaf010', urlCpnItem: '/pajaa010', context: '추천 인재', icon: 'icon icon-nav-light' },
    { url: '/pajag010', urlCpnItem: '/pajaa010', context: '스크랩', icon: 'icon icon-nav-star' },
    { url: '/pajah010', urlCpnItem: '/pajah020', context: '쪽지', icon: 'icon icon-nav-letter' },
    // { url: '/paiaf030', urlCpnItem: '/pajaa010', context: '쪽지', icon: 'icon icon-nav-letter' },
    { url: '/pajai010', urlCpnItem: '/pajaa010', context: 'DV Point 조회', icon: 'icon icon-nav-coins' },
    { url: '/pajaj010', urlCpnItem: '/pajaa010', context: '내 정보 잠금 설정', icon: 'icon icon-nav-lock' },
    { url: '/pajaj020', urlCpnItem: '/pajaa010', context: '내 정보 수정', icon: 'icon icon-nav-setting' },
    { url: '/pajaj040', urlCpnItem: '/pajaa010', context: '회원 탈퇴', icon: 'icon icon-nav-logout' },
];

export const MESSAGE = {
    confirm: {
        create: '등록하시겠습니까?',
        update: '저장하시겠습니다?',
        delete: '삭제하시겠습니까?',
    },
    code: {
        200: 'Success',
        400: 'Bad Request',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Not Found',
        500: 'Internal Server Error',
    },
    notify: {
        createSuccess: '등록완료 되었습니다.',
        createError: '오류가 발생했습니다.',
        updateSuccess: '업데이트완료 되었습니다.',
        updateError: '오류가 발생했습니다.',
        deleteSuccess: '삭제완료 되었습니다.',
        deleteError: '오류가 발생했습니다.',
        saveSuccess: '저장완료 되었습니다.',
    },
};

export const MOBIPHONE_OPTIONS = [
    { value: '010', option: '010' },
    { value: '033', option: '033' },
    { value: '041', option: '041' },
    { value: '042', option: '042' },
    { value: '043', option: '043' },
    { value: '044', option: '044' },
    { value: '052', option: '052' },
    { value: '053', option: '053' },
    { value: '054', option: '054' },
    { value: '055', option: '055' },
    { value: '061', option: '061' },
    { value: '062', option: '062' },
    { value: '063', option: '063' },
    { value: '064', option: '064' },
    { value: '070', option: '070' },
    { value: '011', option: '011' },
    { value: '016', option: '016' },
    { value: '017', option: '017' },
    { value: '018', option: '018' },
    { value: '019', option: '019' },
];

export const PHONE_OPTIONS = [
    { option: '02', value: '02' },
    { option: '031', value: '031' },
    { option: '032', value: '032' },
    { option: '033', value: '033' },
    { option: '041', value: '041' },
    { option: '042', value: '042' },
    { option: '043', value: '043' },
    { option: '044', value: '044' },
    { option: '051', value: '051' },
    { option: '052', value: '052' },
    { option: '053', value: '053' },
    { option: '054', value: '054' },
    { option: '055', value: '055' },
    { option: '061', value: '061' },
    { option: '062', value: '062' },
    { option: '063', value: '063' },
    { option: '064', value: '064' },
    { option: '070', value: '070' },
    { option: '010', value: '010' },
    { option: '011', value: '011' },
    { option: '016', value: '016' },
    { option: '017', value: '017' },
    { option: '018', value: '018' },
    { option: '019', value: '019' },
];

export const BIZ_TYPE_OPTIONS = [
    { code: '001', codeName: '치과의원' },
    { code: '002', codeName: '치과병원' },
    { code: '003', codeName: '치과기공소' },
    { code: '004', codeName: '종합병원' },
    { code: '005', codeName: '네트워크치과' },
    { code: '006', codeName: '신규개원' },
    { code: '999', codeName: '일반(기타)' },
];
